import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { recipeApi, setSession } from "@/lib/recipeApi";

const RecipesLoginPage = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      toast.error("Enter your email and password");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await recipeApi.login(email.trim(), password);
      setSession(data.token, data.user);
      toast.success("Welcome back");
      nav("/recipes/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-[#0A0A0A] min-h-screen text-white pt-28 pb-20 px-6" data-testid="recipes-login-page">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <p className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase mb-3">
            Recipe Members
          </p>
          <h1
            className="font-display text-5xl leading-none tracking-tight"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            LOG <span className="text-[#D4AF37]">IN</span>
          </h1>
        </div>
        <form
          onSubmit={submit}
          className="border border-[#1A1A1A] bg-black/60 p-6 sm:p-8 space-y-4"
          data-testid="login-form"
        >
          <div>
            <label className="text-[11px] tracking-[0.2em] uppercase text-white/60 mb-2 block font-semibold">
              Email
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="premium-input rounded"
              placeholder="you@email.com"
              autoComplete="email"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-[11px] tracking-[0.2em] uppercase text-white/60 mb-2 block font-semibold">
              Password
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="premium-input rounded"
              placeholder="••••••••"
              autoComplete="current-password"
              data-testid="login-password"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#D4AF37] text-black hover:bg-white rounded-none py-6 text-xs tracking-[0.25em] uppercase font-bold"
            data-testid="login-submit"
          >
            {submitting ? (
              <>
                <Loader2 size={14} className="mr-2 animate-spin" />
                LOGGING IN
              </>
            ) : (
              <>
                Log In
                <ArrowRight size={14} className="ml-2" />
              </>
            )}
          </Button>
        </form>
        <p className="text-center mt-6 text-white/50 text-sm">
          Don&rsquo;t have access yet?{" "}
          <Link to="/recipes" className="text-[#D4AF37] hover:underline">
            Unlock for $20
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RecipesLoginPage;
